import { Badge } from "reactstrap";
import FilePreview from "./file-preview";
import Flex from "@components/ui-components/flex";
import LoadingButton from "@components/ui-components/loading-button";
import { extractName } from "../misc/constants";
import size from "lodash/size";
import useEmailThread from "./use-email-thread";
import { useTranslation } from "react-i18next";

const EmailThread = ({ thread }) => {
    const {
        loading,
        toggleView,
        attachmentResponse,
        viewAttachmentConfig
    } = useEmailThread({ thread });

    const { t } = useTranslation();

    return (
        <>
            {thread.map((email) => {
                return (
                    <>
                        <div className="border px-1 py-2">
                            <div className="d-flex align-items-baseline">
                                <h5 className="text-muted">{t("From")}</h5>
                                <Badge color="primary" className="ms-25">
                                    {extractName(email.sender) ? `${extractName(email.sender).name} (${extractName(email.sender).email})` : email.sender}
                                </Badge>
                            </div>
                            <hr />
                            <div className="d-flex align-items-baseline flex-wrap gap-25">
                                <span className="font-medium-2 text-muted">{t("To")}:</span>
                                {email.to.split(", ") ? (
                                    email.to.split(", ").map(split => {
                                        return (
                                            <Badge color="primary" className="ms-25">
                                                {extractName(split) ? `${extractName(split).name} (${extractName(split).email})` : split}
                                            </Badge>
                                        );
                                    })
                                ) : (
                                    <Badge color="primary" className="ms-25 mb-1">
                                        {extractName(email.to) ? `${extractName(email.to).name} (${extractName(email.to).email})` : email.to}
                                    </Badge>
                                )}
                            </div>
                            <hr />
                            {size(email.cc) ? (
                                <div className="d-flex align-items-baseline flex-wrap gap-25">
                                    <span className="border px-1 py-1 text-muted">{t("CC")}:</span>
                                    {email.cc.split(", ") ? (
                                        email.cc.split(", ").map(split => {
                                            return (
                                                <Badge color="primary" className="ms-25 mb-25">
                                                    {extractName(split) ? `${extractName(split).name} (${extractName(split).email})` : split}
                                                </Badge>
                                            );
                                        })
                                    ) : (
                                        <Badge color="primary" className="ms-25 mb-25">
                                            {extractName(email.cc) ? `${extractName(email.cc).name} (${extractName(email.cc).email})` : email.cc}
                                        </Badge>
                                    )}
                                </div>
                            ) : null}
                            {size(email.bcc) ? (
                                <div className="d-flex align-items-baseline flex-wrap gap-25">
                                    <span className="border px-1 py-2 text-muted">{t("BCC")}:</span>
                                    {email.bcc?.split(", ") ? (
                                        email.bcc.split(", ").map(split => {
                                            return (
                                                <Badge color="primary" className="ms-25 mb-25">
                                                    {extractName(split) ? `${extractName(split).name} (${extractName(split).email})` : split}
                                                </Badge>
                                            );
                                        })
                                    ) : (
                                        <Badge color="primary" className="ms-25 mb-25">
                                            {extractName(email.bcc) ? `${extractName(email.bcc).name} (${extractName(email.bcc).email})` : email.bcc}
                                        </Badge>
                                    )}
                                </div>
                            ) : null}
                        </div>
                        <div
                            className="border p-50 bg-light-secondary mt-1 rounded"
                            dangerouslySetInnerHTML={{ __html: email.body }}/>
                        {email.hasAttachment && (
                            <Flex className="w-100 mt-1" justify="end">
                                <LoadingButton
                                    onClick={() => toggleView(viewAttachmentConfig.open ? "" : email.message_id)}
                                    text={`${viewAttachmentConfig.open ? "Hide" : "View"} Attachment`}/>
                            </Flex>
                        )}
                        {viewAttachmentConfig.open &&
                            viewAttachmentConfig.id === email.message_id && (
                            <FilePreview
                                attachmentResponse={attachmentResponse}
                                loading={loading}/>
                        )}
                    </>
                );
            })}
        </>
    );
};

export default EmailThread;
